import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SkillsCheckerService} from '../service/skills-checker.service';
import {SkillsCheckerFormModel, SkillsCheckerFormRequestModel} from '../model/skills-checker-form.model';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {AlertController} from '@ionic/angular';
import {UserService} from '../../../services/user.service';
import {EventsService} from '../../../services/events.service';
import {TranslateService} from '@ngx-translate/core';
import {NavService} from '../../../services/nav.service';
import {AnalyticsService} from '../../../services/analytics.service';

@Component({
    selector: 'app-skills-checker-form',
    templateUrl: './skills-checker-form.component.html',
    styleUrls: ['./skills-checker-form.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]

})
export class SkillsCheckerFormComponent implements OnInit {
    radioGroup = [
        {text: '__SC_SUMMARY_NA__', value: '-1', class: 'smaller'},
        {text: '1', value: '1', class: ''},
        {text: '2', value: '2', class: ''},
        {text: '3', value: '3', class: ''},
        {text: '4', value: '4', class: ''},
        {text: '5', value: '5', class: ''}
    ];

    scId = 0; // tslint:disable-line:variable-name
    delegateId = 0; // tslint:disable-line:variable-name
    type = 'self';

    dataForm: SkillsCheckerFormModel = null;
    dataFormPromise: Promise<SkillsCheckerFormModel> = null;
    prevCompetency = '';

    constructor(
        private analytics: AnalyticsService,
        private skillsCheckerService: SkillsCheckerService,
        private activatedRoute: ActivatedRoute,
        private alertController: AlertController,
        public userService: UserService,
        private nav: NavService,
        private translate: TranslateService,
        private event: EventsService
    ) {
        this.type = this.activatedRoute.snapshot.data.type;
        if (this.type === 'self') {
            this.delegateId = this.userService.getCurrentUserInfo().id;
        } else {
            this.delegateId = Number(this.activatedRoute.snapshot.paramMap.get('del_id'));
        }
        this.scId = Number(this.activatedRoute.snapshot.paramMap.get('sc_id'));
    }

    ngOnInit() {
        this.dataFormPromise = this.skillsCheckerService.getSkillsCheckerForm(this.scId, this.delegateId);
    }

    ionViewDidEnter() {
        this.analytics.trackView('SkillsChecker Form (' + this.type + ')');

        this.dataFormPromise.then(data => {
            this.dataForm = data;
        }).catch(e => {
            console.error('Error in getSkillsCheckerForm', e);
            return null;
        });
    }

    onChange(event) {
        this.event.publish('form:changed', 'skills-checker');
    }

    onSave() {
        let completed = true;
        if (this.type === 'self') {
            completed = (this.dataForm.questions.value.filter((item) => item.q_value_self.value === -2).length === 0);
        } else if (this.type === 'manager') {
            completed = (this.dataForm.questions.value.filter((item) => item.q_value_manager.value === -2).length === 0);
        } else if (this.type === 'agreed') {
            completed = (this.dataForm.questions.value.filter((item) => item.q_value_agreed.value === -2).length === 0);
        }

        if (completed) {
            this.saveForm();
        } else {
            this.alertController.create({
                header: this.translate.instant('__SC_FORM_WARNING_TITLE__'),
                message: this.translate.instant('__SC_FORM_WARNING_MESSAGE__'),
                buttons: [{
                    text: this.translate.instant('__SC_FORM_WARNING_SAVE__'),
                    cssClass: 'alert-controller-warning',
                    handler: () => {
                        this.saveForm();
                    }
                }, this.translate.instant('__SC_FORM_WARNING_CANCEL__')]
            }).then(a => a.present());
        }
    }

    saveForm() {
        const model: SkillsCheckerFormRequestModel = {
            type: this.type,
            form: this.dataForm
        };

        this.skillsCheckerService.saveSkillsCheckerForm(model)
            .then(data => {
                if (data.status !== null) {
                    this.event.publish('form:saved', {name: 'skills-checker', id: this.dataForm.grp_id});

                    this.analytics.trackEvent('sk_update', {
                        sk_id: this.dataForm.grp_id.toString(),
                        sk_type: this.type,
                    });

                    this.alertController.create({
                        header: this.translate.instant('__ALERT_SUCCESS_TITLE__'),
                        message: this.translate.instant(data.status.message),
                        buttons: [{
                            text: this.translate.instant('__ALERT_SUCCESS_BUTTON__'),
                            handler: () => {
                                this.nav.back();
                            }
                        }]
                    }).then(a => a.present());
                } else {
                    this.dataForm = data.form;
                    this.analytics.trackEvent('exception', {
                        description: 'SkillsChecker Form Save Error: ' + this.dataForm.error,
                        fatal: false
                    });
                    this.alertController.create({
                        header: this.translate.instant('__ALERT_ERROR_TITLE__'),
                        message: this.translate.instant(this.dataForm.error),
                        buttons: [this.translate.instant('__ALERT_ERROR_BUTTON__')]
                    }).then(a => a.present());
                }
            })
            .catch(e => {
                console.error('Error in getSkillsCheckerForm', e);
                return null;
            });
    }

    isAlreadyHappened(competency){
        var check = competency != this.prevCompetency;
        this.prevCompetency = competency;
        return check;
    }
}
